<template >
  <div>
    <div class="row top-menu">
      <div class="col-sm-4">
        <v-select v-model="reportType" :options="reportOptions" />
      </div>
      <div class="col-sm-4">
        <MailboxSelector @selected="updateMailbox"/>
      </div>
      <div class="col-sm-4">
        <CompareDatesSelector />
      </div>
    </div>
    <transition name="fade">
      <div>
        <div v-if="loadError === true" class="loading">
          <div class="loading-text">
            Error loading report. Please refresh and try again.
          </div>
        </div>
        <div v-else-if="!currentReportMailbox.id && !loadingData" class="loading">
          <div class="loading-text">
            Please select a mailbox above.
          </div>
        </div>
        <div v-else-if="loadingData === true" class="loading">
          <div class="loading-icon">
            <fa icon="sync-alt" spin/>
          </div>
          <div class="loading-text">
            Loading report...
          </div>
        </div>
      </div>
    </transition>
    <template v-if="currentReportMailbox.id">
      <TeamReport v-if="reportType.value==='team'" />
      <AllChannelsReport v-if="reportType.value==='all_channels'"/>
      <ProductivityReport v-if="reportType.value==='productivity'"/>
    </template>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import DateRangeSelector from '@/components/selectors/DateRangeSelector'
import CompareDatesSelector from '@/components/selectors/CompareDatesSelector'
import MailboxOverviewChart from './MailboxOverviewChart'
import MailboxSelector from '@/components/selectors/MailboxSelector'
import AllChannelsReport from './AllChannelsReport'
import ProductivityReport from './ProductivityReport'
export default {
  name: 'AdminReportsIndex',
  components: {
    DateRangeSelector,
    CompareDatesSelector,
    MailboxOverviewChart,
    MailboxSelector,
    AllChannelsReport,
    ProductivityReport
  },
  data () {
    return {
      reportType: {
        value: 'all_channels',
        label: 'Mailbox Overview'
      },
      reportOptions: [
        {value: 'all_channels', label: 'Mailbox Overview'},
        {value: 'productivity', label: 'Productivity'}
      ],
      loadingData: false,
      loadError: false
    }
  },
  computed: {
    ...mapGetters(['currentReportMailbox', 'reportDates'])
  },
  methods: {
    updateMailbox (data) {
      this.$store.commit('setCurrentReportMailbox', data)
      this.loadError = false
    },
    updateDates (data) {
      this.$store.commit('setReportDates', data)
      this.loadError = false
    }
  },
  watch: {
  },
  mounted () {
    this.$root.$on('reportLoadingComplete', () => {
      this.loadingData = false
      this.loadError = false
    })
    this.$root.$on('loadingReport', () => {
      this.loadingData = true
      this.loadError = false
    })
    this.$root.$on('errorLoadingReport', () => {
      this.loadError = true
    })
  }

}
</script>

<style scoped>
.top-menu {
  background: #56bbd2;
}
>>> .v-select {
      background: white;
      margin: 2px;
    }
.loading {
  height: 100vh;
  padding: 5vw;
  text-align: center;
  font-size: calc(~"15px + 1.5vw");
  background-color: #fff;
}
.fade-transition {
  transition: opacity 8000ms ease;
}
.fade-transition.loading {
  z-index: 1;
  position: absolute;
  top: 0;
  left: 15px;
  right: 15px;
}
.fade-enter,
.fade-leave {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/reports/Index.vue